import React from "react";
import { Course } from "@/common/course/types";
import useWebview from "@/webview/useWebview";
import useTranslations from "@/i18n/useTranslations";

interface TechMicrocredentialsCTAProps {
  items: Course[] | null;
}

function TechMicrocredentialsCTA({ items }: TechMicrocredentialsCTAProps) {
  const { getUrl } = useWebview();
  const t = useTranslations("Program");

  return (
    <div className="bg-putty-400 py-14 px-4 md:px-16">
      <div>
        <h2 className="text-center md:text-left text-4xl italic text-secondary-500 font-black font-inter my-0 py-0">
          {t("upgradeToPremiumLearningExperience")}
        </h2>
        <h3 className="text-sm md:text-lg font-bold font-inter leading-6 md:leading-9">
          {t("techMicrocredentialsCohortDescription")}
        </h3>
      </div>
      <div>
        <ul className="!list-none">
          {items?.map((item, index) => {
            const titlePartner = item.partners
              ?.map((obj) => obj.key)
              .join(", ");
            const title = `${titlePartner}: ${item.productName}`;

            return (
              <li
                key={index}
                className={`text-center md:text-left font-inter underline text-base ${index !== items.length - 1 ? "mb-4" : ""}`}
              >
                <a href={getUrl(item.productUrl)} target="_blank">
                  {title} {t("technicalMicrocredential")}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default TechMicrocredentialsCTA;
